import React, { useState } from 'react';
import { Star, Check, ChevronLeft, ChevronRight, PlayCircle, Image as ImageIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const images = ['https://cdn.magicpatterns.com/uploads/mzixfPmPWGNgHuxHHTGZws/ChatGPT_Image_Jun_25,_2026,_02_12_29_AM.png', 'https://cdn.magicpatterns.com/uploads/73XJZbNfWnmeKudEuvvkHF/ChatGPT_Image_Jun_25,_2026,_02_42_07_AM.png', 'https://cdn.magicpatterns.com/uploads/38HfodtymivCakFqjHSVQR/ChatGPT_Image_Jun_25,_2026,_02_18_32_AM.png', 'https://cdn.magicpatterns.com/uploads/xp9k8GezAC1MxgNeRA4UbQ/ChatGPT_Image_Jun_25,_2026,_02_38_06_AM.png'];
export function ProductHero() {
  const [activeImage, setActiveImage] = useState(0);
  const nextImage = () => setActiveImage(prev => (prev + 1) % images.length);
  const prevImage = () => setActiveImage(prev => (prev - 1 + images.length) % images.length);
  return <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12" data-id="element-32">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-33">
        {/* Left Column - Gallery */}
        <div className="flex flex-col space-y-4" data-id="element-34">
          <div className="relative aspect-square bg-[#FDF8F5] rounded-2xl overflow-hidden flex items-center justify-center" data-id="element-35">
            <span className="absolute top-4 left-4 bg-white px-3 py-1 rounded-full text-xs font-bold tracking-wider shadow-sm z-10" data-id="element-36">
              MÁS VENDIDO
            </span>
            <AnimatePresence mode="wait" data-id="element-37">
              <motion.img key={activeImage} src={images[activeImage]} alt="Product Image" className="w-full h-full object-cover" initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} exit={{
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-38" />
            </AnimatePresence>

            {/* Mobile Arrows */}
            <button onClick={prevImage} className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-2 rounded-full shadow-md md:hidden" data-id="element-39">
              <ChevronLeft className="w-5 h-5 text-gray-800" data-id="element-40" />
            </button>
            <button onClick={nextImage} className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-2 rounded-full shadow-md md:hidden" data-id="element-41">
              <ChevronRight className="w-5 h-5 text-gray-800" data-id="element-42" />
            </button>
          </div>

          {/* Thumbnails */}
          <div className="flex space-x-4 overflow-x-auto pb-2 scrollbar-hide" data-id="element-43">
            {images.map((img, idx) => <button key={idx} onClick={() => setActiveImage(idx)} className={`relative flex-shrink-0 w-20 h-20 rounded-xl overflow-hidden border-2 transition-all ${activeImage === idx ? 'border-[#7E354D]' : 'border-transparent hover:border-gray-300'}`} data-id="element-44">
                <img src={img} alt={`Thumbnail ${idx + 1}`} className="w-full h-full object-cover" data-id="element-45" />
              </button>)}
          </div>

          {/* Action Buttons */}
          <div className="grid grid-cols-2 gap-4 mt-6" data-id="element-46">
            <button className="flex items-center justify-center gap-2 py-3 px-4 bg-[#F3E8EA] hover:bg-[#E8D5D8] text-[#4A2B4D] rounded-full font-medium transition-colors border border-[#D5C1C5]" data-id="element-47">
              <PlayCircle className="w-5 h-5" data-id="element-48" />
              Ver por dentro
            </button>
            <button className="flex items-center justify-center gap-2 py-3 px-4 bg-[#F3E8EA] hover:bg-[#E8D5D8] text-[#4A2B4D] rounded-full font-medium transition-colors border border-[#D5C1C5]" data-id="element-49">
              <ImageIcon className="w-5 h-5" data-id="element-50" />
              Ver Bonos
            </button>
          </div>
        </div>

        {/* Right Column - Product Info */}
        <div className="flex flex-col" data-id="element-51">
          {/* Reviews */}
          <div className="flex items-center space-x-2 mb-4" data-id="element-52">
            <div className="flex text-black" data-id="element-53">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-54" />)}
            </div>
            <span className="text-sm text-gray-600 font-medium" data-id="element-55">4.9 / 5</span>
            <span className="text-gray-300" data-id="element-56">•</span>
            <span className="text-sm text-gray-600" data-id="element-57">
              Amado por +2,500 estudiantes
            </span>
          </div>

          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 leading-tight" data-id="element-58">
            RBT en Español: Guía para Pasar el Examen + 3 Bonos
          </h1>

          {/* Price */}
          <div className="flex items-center space-x-3 mb-2" data-id="element-59">
            <span className="text-lg text-gray-500 line-through" data-id="element-60">$69</span>
            <span className="text-3xl font-bold text-gray-900" data-id="element-61">$4.99</span>
          </div>
          <p className="text-sm text-gray-500 mb-6" data-id="element-62"></p>

          <p className="text-lg text-gray-800 font-medium mb-6" data-id="element-63">
            La guía definitiva para mujeres hispanas que quieren aprobar el
            examen RBT entendiendo realmente los conceptos, sin enredos con el
            inglés.
          </p>

          <p className="text-gray-600 mb-6" data-id="element-64">
            Estudia paso a paso, con un lenguaje sencillo y ejemplos fáciles de
            recordar. Incluye todo lo que necesitas para sentirte segura el día
            de tu examen.
          </p>

          {/* Features */}
          <div className="space-y-3 mb-8" data-id="element-65">
            <p className="font-semibold text-gray-900" data-id="element-66">Todo lo que incluye:</p>
            <ul className="space-y-3" data-id="element-67">
              {['Guía completa RBT en Español (PDF)', 'Bono #1: Checklist imprimible de preparación', 'Bono #2: 300 Flashcards bilingües (Inglés/Español)', 'Bono #3: Mock Exam con 85 preguntas explicadas'].map((feature, idx) => <li key={idx} className="flex items-start" data-id="element-68">
                  <Check className="w-5 h-5 text-[#7E354D] mr-3 flex-shrink-0 mt-0.5" data-id="element-69" />
                  <span className="text-gray-700" data-id="element-70">{feature}</span>
                </li>)}
            </ul>
          </div>

          {/* CTA */}
          <a href="https://newdigitalguide.com/cart/42950525616190:1?checkout" className="block text-center w-full bg-[#7E354D] hover:bg-[#5E2538] text-white py-4 rounded-full font-bold text-lg transition-colors shadow-lg mb-4" data-id="element-71">
            COMPRAR AHORA
          </a>

          <div className="flex items-center justify-center space-x-2 text-sm text-gray-600" data-id="element-72">
            <Check className="w-4 h-4 text-green-600" data-id="element-73" />
            <span data-id="element-74">Garantía de satisfacción de 7 días</span>
            <span className="text-gray-300" data-id="element-75">•</span>
            <a href="#" className="underline hover:text-gray-900" data-id="element-76">
              Ver detalles
            </a>
          </div>
        </div>
      </div>
    </section>;
}